import React, {PropTypes} from 'react'
import {DialogButtonGroup, Callout} from '~/components/blueprint'
import workflowService from '~/services/workflowService'
import kdService from '~/services/kitchenDepartmentService'

class SetWorkflow extends React.Component {
  static propTypes = {
    action: PropTypes.object.isRequired,
    storeId: PropTypes.string.isRequired,
    onSaved: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  }
  constructor(props){
    super(props)
    this.fetchWorkflows = this.fetchWorkflows.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.handleChange = this.handleChange.bind(this)
    let {workflow} = props.action.target
    this.state = {
      loading: false,
      workflows: [],
      selected: workflow ? workflow.id : null,
      error: null
    }
  }
  componentWillMount(){
    this.fetchWorkflows()
  }
  async fetchWorkflows(){
    this.setState({loading: true})
    let response = await workflowService.getWorkflows(this.props.storeId)
    let {workflows} = response.data
    this.setState({workflows, loading: false})
  }
  handleChange(event){
    let selected = event.target.value
    this.setState({selected})
  }
  async handleSave(){
    try {
      let {selected} = this.state
      let {id} = this.props.action.target
      await kdService.update(this.props.storeId, {id, workflow_id: selected})
      this.props.onSaved()
      this.props.onCancel()
    } catch (error){
      this.setState({error})
    }
  }
  render(){
    let {onCancel} = this.props
    let {selected, workflows, error} = this.state
    return (
      <div className="dialog-container">
        <div className="pt-select pt-fill">
          <select selected={selected} onChange={this.handleChange}>
            <option value={null}>Choose a workflow...</option>
            {workflows.map(workflow=>(
              <option key={workflow.id} value={workflow.id}>{workflow.name}</option>
            ))}
          </select>
        </div>
        <Callout error={error}/>
        <DialogButtonGroup onCancel={onCancel} onSave={this.handleSave}/>
      </div>
    )
  }
}

export default SetWorkflow



/** WEBPACK FOOTER **
 ** ./client/pages/kitchen-department/SetWorkflow.js
 **/